/* PRODUCT 02 · Website
   The public-facing studio site, template-aware and tenant-themable. */
import React from "react";
import ProductPageLayout from "./ProductPageTemplate";

const UNS = "https://images.unsplash.com";
import { EDITORIAL_ASSETS as _ED } from "@/lib/editorialAssets";

/* Small browser-frame mock for the tilted stack — keeps the tiles
   clearly product-of-Website (not just photos). */
function SiteMock({ title, photo }) {
  return (
    <div className="absolute inset-0 flex flex-col">
      <div className="flex items-center gap-1.5 px-3 h-8 bg-[color:var(--charcoal)]/90 border-b border-[color:var(--gold-foil)]/20">
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold-foil)]/25" />
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold-foil)]/20" />
        <span className="w-2 h-2 rounded-full bg-[color:var(--gold-foil)]/15" />
        <span className="ml-3 text-[9px] tracking-[0.18em] uppercase text-[color:var(--cream)]/45 font-mono truncate">{title}</span>
      </div>
      <div className="flex-1 relative overflow-hidden">
        <img src={photo} alt="" loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[color:var(--charcoal)]/85 via-[color:var(--charcoal)]/10 to-transparent" />
        <div className="absolute bottom-3 left-3 right-3">
          <div className="text-[9px] tracking-[0.22em] uppercase text-[color:var(--gold-foil)]">Editorial · Tenant theme</div>
          <div className="mt-1 text-base font-serif italic text-[color:var(--cream)]">A studio at home in the world.</div>
        </div>
      </div>
    </div>
  );
}

export default function WebsitePage() {
  return (
    <ProductPageLayout
      chapter="02"
      label="Website"
      headline={<>A public site as <em>considered</em> as your work.</>}
      descriptor="Ten templates, your brand, your domain. Each tenant site is theme-aware down to the kerning — and ships with a CMS quiet enough that the headline always wins."
      features={["CUSTOM DOMAIN","10 TEMPLATES","TENANT THEMING","CMS","SEO READY"]}
      primaryCta={{ label: "Preview a live site \u2192", href: "/s/allure-image" }}
      secondaryCta={{ label: "Pricing \u2192", href: "/marketing#pricing" }}
      previewItems={[
        { render: <SiteMock title="alluremaison.com" photo={_ED.editorial_couple_warm.src} /> },
        { render: <SiteMock title="studio-aria.com"  photo={_ED.editorial_maternity.src} /> },
        { render: <SiteMock title="aurore.studio"     photo={_ED.editorial_bw_portrait.src} /> },
      ]}
    />
  );
}
